import { Link } from 'react-router-dom';
import { CoupleNames } from '../components/CoupleNames';
import { Grain, Thoranam } from '../components/Thoranam';
import { NavBar } from '../components/NavBar';

export function CoverPage() {
  return (
    <div className="shell">
      <div className="bg bg-cover" />
      <Thoranam />
      <Grain />
      <NavBar />
      <main className="cover-copy">
        <div>
          <p className="kicker">A private family album</p>
          <p className="ceremony">Shastiapthapoorthi</p>
          <CoupleNames />
          <p className="sub">Sixty years, renewed in the manner of a wedding</p>
          <p className="date-chip">10 August 2026</p>
          <hr className="gold-rule" />
          <div className="btn-row">
            <Link className="btn gold" to="/album">
              Open the album
            </Link>
            <Link className="btn" to="/film">
              Recording
            </Link>
          </div>
        </div>
      </main>
    </div>
  );
}
